import React, { useState } from 'react';
import {
    useJsApiLoader,
    GoogleMap,
    Marker,
    Autocomplete,
} from '@react-google-maps/api';
import { Box, Typography, Button, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const libraries = ['places'];

const MapPage = () => {
    const [autocomplete, setAutocomplete] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [currentLocation, setCurrentLocation] = useState(null);
    const navigate = useNavigate();

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_APIKEY,
        libraries,
    });

    const onLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            const place = autocomplete.getPlace();
            const location = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
                description: place.formatted_address,
            };
            setSelectedLocation(location);
        }
    };

    const fetchCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const location = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        description: 'Current Location',
                    };
                    setSelectedLocation(location);
                    setCurrentLocation(location);
                },
                (error) => {
                    console.error('Error fetching location:', error.message);
                }
            );
        } else {
            console.error('Geolocation is not supported by this browser.');
        }
    };

    const handleContinue = () => {
        if (selectedLocation) {
            // Navigate to the next step with the selected location
            navigate('/request-details', {
                state: { location: selectedLocation },
            });
        } else {
            alert('Please select a location.');
        }
    };

    return (
        <Box>
            <Typography variant='h4' align='center' gutterBottom>
                Select Your Location
            </Typography>

            <Box sx={{ mb: 4 }}>
                {isLoaded && (
                    <Autocomplete
                        onLoad={onLoad}
                        onPlaceChanged={onPlaceChanged}>
                        <TextField
                            label='Search location'
                            variant='outlined'
                            fullWidth
                            placeholder='Enter a location'
                            InputProps={{
                                style: { height: '40px' },
                            }}
                            sx={{ mb: 2 }}
                        />
                    </Autocomplete>
                )}

                <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    onClick={fetchCurrentLocation}
                    sx={{ mb: 2 }}>
                    Use Current Location
                </Button>

                {isLoaded && selectedLocation && (
                    <GoogleMap
                        center={{
                            lat: selectedLocation.lat,
                            lng: selectedLocation.lng,
                        }}
                        zoom={15}
                        mapContainerStyle={{
                            width: '100%',
                            height: '400px',
                            marginBottom: '20px',
                        }}>
                        <Marker
                            position={{
                                lat: selectedLocation.lat,
                                lng: selectedLocation.lng,
                            }}
                        />
                    </GoogleMap>
                )}

                {currentLocation && (
                    <Typography variant='body2' align='center' sx={{ mb: 2 }}>
                        Current Location: {currentLocation.lat},{' '}
                        {currentLocation.lng}
                    </Typography>
                )}

                <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    onClick={handleContinue}>
                    Continue
                </Button>
            </Box>
        </Box>
    );
};

export default MapPage;
